// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["../vendor/swiper"], () => (__webpack_require__("F:\\XAMPP\\htdocs\\projects2026\\imado25\\wp-content\\themes\\imado\\blocks\\testimonials\\index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
